import { render, staticRenderFns } from "./tableView.vue?vue&type=template&id=616ca19e&scoped=true&"
import script from "./tableView.vue?vue&type=script&lang=js&"
export * from "./tableView.vue?vue&type=script&lang=js&"
import style0 from "./tableView.vue?vue&type=style&index=0&id=616ca19e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616ca19e",
  null
  
)

export default component.exports